import {
    apiConstants,
    URBAN_PROCESS_FIELDS,
    URBAN_PROCESS_SEARCH_FIELDS,
    PROVIDER
} from '../config';

let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'GU_00001',
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'backoffice.titles',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'GU_00076',
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            layerswitcher: {
                acl: {
                    view: 'GU_00079',
                },
            },
            streetview: {
                acl: {
                    view: 'GU_00078',
                },
            },
            annotations: {
                acl: {
                    view: 'GU_00125',
                },
            },
            layers: {
                active: true,
                title: 'layers.titles',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'GU_00074',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'GU_00077',
                },
            },
            regulations: {
                active: true,
                title: 'regulations.titles',
                label: 'regulations.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'GU_00083',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    },{
                        'id': 'gu-urbanism',
                        'name': 'Urbanismo',
                        'url': `${codeAPI}/urbanplanning/search/urbanism`,
                        'labelTemplate': '${label}',
                        'listTemplate': '${name}',
                        'listGroup': 'type',
                        'placeholder': 'Urbanismo...',
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
            },
            catalog: {
                acl: {
                    view: 'GU_00081',
                },
            },
            identify: {
                acl: {
                    view: 'GU_00082',
                },
            },
            dashboard: {
                active: true,
                title: 'dashboard.titles',
                label: 'dashboard.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'GU_00077',
                },
                url: {
                    getLists: `${codeAPI}/urbanplanning/urbanprocesses/search/lists`,
                }
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'GU_00080',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            urban_process_search: {
                active: true,
                title: 'urban_process_search.titles',
                label: 'urban_process_search.label',
                panel: {
                    show: false,
                    loaded: false,
                    formatExportData: 'xls',
                    provider: PROVIDER.DATABASE,
                    fields: {
                        database: [
                            URBAN_PROCESS_SEARCH_FIELDS.PROCESS,
                            URBAN_PROCESS_SEARCH_FIELDS.SUBJECT,
                            URBAN_PROCESS_SEARCH_FIELDS.DICOFRE,
                            URBAN_PROCESS_SEARCH_FIELDS.ADDRESS,
                            URBAN_PROCESS_SEARCH_FIELDS.CLASSIFICATION,
                            URBAN_PROCESS_SEARCH_FIELDS.REGIME,
                            URBAN_PROCESS_SEARCH_FIELDS.OWNER,
                            URBAN_PROCESS_SEARCH_FIELDS.ARCHITECTURE_TECNICIAN,
                            URBAN_PROCESS_SEARCH_FIELDS.RESPONSIBLE_TECNICIAN,
                            URBAN_PROCESS_SEARCH_FIELDS.DATE,
                            URBAN_PROCESS_SEARCH_FIELDS.USE,
                            URBAN_PROCESS_SEARCH_FIELDS.PROCEDURE,
                            URBAN_PROCESS_SEARCH_FIELDS.CONSTRUCTION,
                            URBAN_PROCESS_SEARCH_FIELDS.STATUS,
                            URBAN_PROCESS_SEARCH_FIELDS.FINANCES,
                            URBAN_PROCESS_SEARCH_FIELDS.CONSERVATORY,
                        ],
                        airc: [
                            URBAN_PROCESS_SEARCH_FIELDS.PROCESS,
                            URBAN_PROCESS_SEARCH_FIELDS.SUBJECT,
                            URBAN_PROCESS_SEARCH_FIELDS.DICOFRE,
                            URBAN_PROCESS_SEARCH_FIELDS.ADDRESS,
                            URBAN_PROCESS_SEARCH_FIELDS.CLASSIFICATION,
                            URBAN_PROCESS_SEARCH_FIELDS.REGIME,
                            URBAN_PROCESS_SEARCH_FIELDS.OWNER,
                            URBAN_PROCESS_SEARCH_FIELDS.DATE,
                        ],
                        medidata: [
                            URBAN_PROCESS_SEARCH_FIELDS.PROCESS,
                            URBAN_PROCESS_SEARCH_FIELDS.SUBJECT,
                            URBAN_PROCESS_SEARCH_FIELDS.DICOFRE,
                            URBAN_PROCESS_SEARCH_FIELDS.ADDRESS,
                            URBAN_PROCESS_SEARCH_FIELDS.CLASSIFICATION,
                            URBAN_PROCESS_SEARCH_FIELDS.REGIME,
                            URBAN_PROCESS_SEARCH_FIELDS.OWNER,
                            URBAN_PROCESS_SEARCH_FIELDS.ARCHITECTURE_TECNICIAN,
                            URBAN_PROCESS_SEARCH_FIELDS.RESPONSIBLE_TECNICIAN,
                            URBAN_PROCESS_SEARCH_FIELDS.DATE,
                            URBAN_PROCESS_SEARCH_FIELDS.USE,
                            URBAN_PROCESS_SEARCH_FIELDS.PROCEDURE,
                            URBAN_PROCESS_SEARCH_FIELDS.CONSTRUCTION,
                            URBAN_PROCESS_SEARCH_FIELDS.STATUS,
                            URBAN_PROCESS_SEARCH_FIELDS.FINANCES,
                            URBAN_PROCESS_SEARCH_FIELDS.CONSERVATORY,
                        ]
                    },
                    export: {
                        formats: [
                            {
                                format: 'csv',
                                title: 'urban_processes.export.data.csv.title',
                                name: 'urban_processes.export.data.csv.name',
                                icon: 'fas fa-file-csv',
                                status: 1,
                            },
                            {
                                format: 'xls',
                                title: 'urban_processes.export.data.xls.title',
                                name: 'urban_processes.export.data.xls.name',
                                icon: 'fas fa-file-excel',
                                status: 1,
                            },
                            {
                                format: 'kml',
                                title: 'urban_processes.export.data.kml.title',
                                name: 'urban_processes.export.data.kml.name',
                                icon: 'fas fa-file-code',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'gml',
                                title: 'urban_processes.export.data.gml.title',
                                name: 'urban_processes.export.data.gml.name',
                                icon: 'fas fa-file-archive',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'geojson',
                                title: 'urban_processes.export.data.geojson.title',
                                name: 'urban_processes.export.data.geojson.name',
                                icon: 'fas fa-file-code',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'shp',
                                title: 'urban_processes.export.data.shp.title',
                                name: 'urban_processes.export.data.shp.name',
                                icon: 'fas fa-file-archive',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'gpkg',
                                title: 'urban_processes.export.data.gpkg.title',
                                name: 'urban_processes.export.data.gpkg.name',
                                icon: 'fas fa-database',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'pdf',
                                title: 'urban_processes.export.data.pdf.title',
                                name: 'urban_processes.export.data.pdf.name',
                                icon: 'fas fa-file-pdf',
                                status: 0,
                            },
                            {
                                type: 'ine',
                                format: 'xls',
                                title: 'urban_processes.export.data.ine.title',
                                name: 'urban_processes.export.data.ine.name',
                                // icon: 'fas fa-file-pdf',
                                img: '/icons/ine.svg',
                                status: 1,
                            }
                        ],
                    }
                },
                acl: {
                    view: 'GU_00084',
                    show: 'GU_00084',
                    editAreas: 'GU_00095',
                    associateAreas: 'GU_00097',
                    associateProcesses: 'GU_00102',
                    disassociateProcesses: 'GU_00103',
                    analysissurroundingspace: 'GU_00113',
                    confrontation: 'GU_00098',
                    export: 'GU_00099',
                    link: 'xxxxx',
                    unlink: 'xxxxx',
                },
                url: {
                    searchAll: `${codeAPI}/urbanplanning/urbanprocesses/search`,
                    getLists: `${codeAPI}/urbanplanning/urbanprocesses/search/lists`,
                    export: `${codeAPI}/urbanplanning/urbanprocesses/search/export/:type`,
                    job: `${codeAPI}/urbanplanning/urbanprocesses/search/export/job/:id`,
                    geomObject: `${codeAPI}/urbanplanning/urbanprocesses/geometry/:id`,
                },
            },
            urban_processes: {
                model: 'urban_processes',
                active: true,
                panel: {
                    show: false,
                    provider: PROVIDER.DATABASE,
                    fields: {
                        required: {
                            database: [
                                URBAN_PROCESS_FIELDS.PROCESS,
                                URBAN_PROCESS_FIELDS.CLASSIFICATION,
                                URBAN_PROCESS_FIELDS.STATUS,
                                URBAN_PROCESS_FIELDS.CONSTRUCTION,
                                URBAN_PROCESS_FIELDS.OWNER,
                            ],
                            airc: [
                                URBAN_PROCESS_FIELDS.PROCESS,
                                URBAN_PROCESS_FIELDS.CLASSIFICATION,
                                URBAN_PROCESS_FIELDS.STATUS,
                                URBAN_PROCESS_FIELDS.CONSTRUCTION,
                                URBAN_PROCESS_FIELDS.OWNER,
                            ],
                            medidata: [
                                URBAN_PROCESS_FIELDS.PROCESS,
                                URBAN_PROCESS_FIELDS.CLASSIFICATION,
                                URBAN_PROCESS_FIELDS.STATUS,
                            ],
                        }
                    },
                    inspections: {
                        upload: {
                            maxFiles: 3,
                            acceptTypes: [
                                'application/msword',
                                'application/vnd.ms-excel',
                                'application/vnd.ms-powerpoint',
                                'application/pdf',
                                'image/x-png',
                                'image/png',
                                'image/jpeg',
                                'image/bmp',
                                'image/gif',
                                'image/svg+xml',
                            ],
                        },
                    },
                    documents: {
                        upload: {
                            acceptTypes: [
                                'application/vnd.ms-powerpoint',
                                'application/mspowerpoint',
                                'application/vnd.ms-excel',
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                'application/msword',
                                'application/vnd.ms-word.template.macroEnabled.12',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
                                'application/pdf',
                                'image/jpeg',
                                'image/bmp',
                                'image/x-png',
                                'image/png',
                                'image/gif',
                                'image/svg+xml',
                                'application/geo+json',
                                'application/json',
                                'application/gml+xml',
                                'application/vnd.google-earth.kml+xml',
                                'application/vnd.google-earth.kmz',
                                'application/gpx+xml',
                                'text/gpx',
                                'text/gpsxml',
                                'application/gpsxml',
                                'application/x-osm+xml',
                                'text/plain',
                                'text/csv',
                                'text/tab-separated-values',
                                'image/tiff',
                                'application/vnd.sqlite3',
                                'application/x-sqlite3',
                                'application/dxf',
                                'application/acad',
                                'application/x-dxf',
                                'application/x-acad',
                                'application/x-autocad',
                                'drawing/x-dxf',
                                'image/vnd.dxf',
                                'image/x-autocad',
                                'image/x-dxf',
                                'application/autocad_dwg',
                                'image/x-dwg',
                                'application/dwg',
                                'application/x-dwg',
                                'application/x-autocad',
                                'image/vnd.dwg',
                                'drawing/dwg',
                                'application/x-msaccess',
                                'application/vnd.shp',
                                'application/x-mif',
                                'application/geopackage+sqlite3',
                                'application/dgn',
                                'image/vnd.dgn',
                                'image/ecw',
                                'image/sid',
                                'application/vnd.mapbox-vector-tile',
                                'application/vnd.vector-tile',
                                'x-world/x-vrt',
                                'application/x--ogc--zmap',
                                'image/webp',
                                '.dwg',
                                '.dxf',
                                '.geojson',
                                '.gml',
                                '.kml',
                                '.kmz',
                                '.gpx',
                                '.osm',
                                '.tsv',
                                '.sqlite',
                                '.sqlite3',
                                '.mdb',
                                '.shp',
                                '.mif',
                                '.gpkg',
                                '.dgn',
                                '.ecw',
                                '.sid',
                                '.mbtiles',
                                '.vrt',
                            ],
                        }
                    },
                    surrounding_space_analysis: {
                        meters: 100,
                    },
                    export: {
                        formats: [
                            {
                                format: 'csv',
                                title: 'urban_processes.export.data.csv.title',
                                name: 'urban_processes.export.data.csv.name',
                                icon: 'fas fa-file-csv',
                                status: 1,
                            },
                            {
                                format: 'xls',
                                title: 'urban_processes.export.data.xls.title',
                                name: 'urban_processes.export.data.xls.name',
                                icon: 'fas fa-file-excel',
                                status: 1,
                            },
                            {
                                format: 'kml',
                                title: 'urban_processes.export.data.kml.title',
                                name: 'urban_processes.export.data.kml.name',
                                icon: 'fas fa-file-code',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'gml',
                                title: 'urban_processes.export.data.gml.title',
                                name: 'urban_processes.export.data.gml.name',
                                icon: 'fas fa-file-archive',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'geojson',
                                title: 'urban_processes.export.data.geojson.title',
                                name: 'urban_processes.export.data.geojson.name',
                                icon: 'fas fa-file-code',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'shp',
                                title: 'urban_processes.export.data.shp.title',
                                name: 'urban_processes.export.data.shp.name',
                                icon: 'fas fa-file-archive',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'gpkg',
                                title: 'urban_processes.export.data.gpkg.title',
                                name: 'urban_processes.export.data.gpkg.name',
                                icon: 'fas fa-database',
                                geographic: 1,
                                status: 1,
                            },
                            {
                                format: 'pdf',
                                title: 'urban_processes.export.data.pdf.title',
                                name: 'urban_processes.export.data.pdf.name',
                                icon: 'fas fa-file-pdf',
                                status: 0,
                            },
                            {
                                type: 'ine',
                                format: 'xls',
                                title: 'urban_processes.export.data.ine.title',
                                name: 'urban_processes.export.data.ine.name',
                                img: '/icons/ine.svg',
                                status: 1,
                            }
                        ],
                    }
                },
                acl: {
                    view: 'GU_00092',
                    show: 'GU_00092',
                    add: 'GU_00093',
                    edit: 'GU_00094',
                    delete: 'GU_00096',
                    export: 'GU_00099',
                    analysissurroundingspace: 'GU_00113',
                    associateAreas: 'GU_00097',
                    confrontation: 'GU_00098',
                    editAreas: 'GU_00095',
                    editConservatory: 'GU_00106',
                    editDocuments: 'GU_00119',
                    editEntities: 'GU_00108',
                    editFinances: 'GU_00107',
                    editGeneral: 'GU_00104',
                    editInspections: 'GU_00110',
                    editRequirements: 'GU_00109',
                    editTechnicalInformation: 'GU_00105',
                },
                url: {
                    show: `${codeAPI}/urbanplanning/urbanprocesses/:id`,
                    showByProcess: `${codeAPI}/urbanplanning/urbanprocesses/processes/:process`,
                    export: `${codeAPI}/urbanplanning/urbanprocesses/export/:id?format=:format&type=:type`,
                    job: `${codeAPI}/urbanplanning/urbanprocesses/export/job/:id`,
                    create: `${codeAPI}/urbanplanning/urbanprocesses`,
                    update: `${codeAPI}/urbanplanning/urbanprocesses/:id`,
                    delete: `${codeAPI}/urbanplanning/urbanprocesses/:id`,
                    getLists: `${codeAPI}/urbanplanning/urbanprocesses/lists/:id`,
                    editArea: `${codeAPI}/urbanplanning/urbanprocesses/areas/:id`,
                    associateAreas: `${codeAPI}/urbanplanning/urbanprocesses/areas/associate/:id`,
                    confrontations: `${codeAPI}/urbanplanning/urbanprocesses/confrontations/:id`,
                }
            },
            urban_process_confrontations: {
                model: 'urban_processes',
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'GU_00098',
                },
                url: {
                    create: `${codeAPI}/urbanplanning/urbanprocesses/confrontations/report`,
                    status: `${codeAPI}/urbanplanning/urbanprocesses/confrontations/job/:id`,
                    export: `${codeAPI}/urbanplanning/urbanprocesses/confrontations`,
                }
            },
            urban_process_associate_areas: {
                model: 'limit_types',
                active: true,
                panel: {
                    show: false,
                    draw: {
                        status: 0,
                        types: [
                            'polygon'
                        ],
                        minfeatures: 0,
                        maxfeatures: 0,
                    },
                    upload: {
                        status: 0,
                        filterProperty: 'Layer',
                    }
                },
                acl: {
                    view: 'GU_00097',
                    edit: 'GU_00095'
                },
                url: {
                    getLists: `${codeAPI}/urbanplanning/urbanprocesses/areas/associate/lists`,
                    togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                }
            },
            urban_areas: {
                model: 'urban_areas',
                active: true,
                panel: {
                    show: false,
                    showState: false,
                },
                acl: {
                    view: 'GU_00111',
                    add: 'GU_00101',
                    delete: 'GU_00112',
                    associateProcesses: 'GU_00102',
                    disassociateProcesses: 'GU_00103',
                },
                url: {
                    show: `${codeAPI}/urbanplanning/urbanareas/:id`,
                    create: `${codeAPI}/urbanplanning/urbanareas`,
                    update: `${codeAPI}/urbanplanning/urbanareas/:id`,
                    delete: `${codeAPI}/urbanplanning/urbanareas/:id`,
                    getLists: `${codeAPI}/urbanplanning/urbanareas/lists/:id`,
                    associateProcesses: `${codeAPI}/urbanplanning/urbanareas/processes/associate/:id`,
                    disassociateProcesses: `${codeAPI}/urbanplanning/urbanareas/processes/disassociate/:id`,
                }
            },
        },
         map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    search: {
                        source: 'vs_search',
                        layer: 'lyr_search',
                        zindex: 1000,
                        timeout: 10000,
                        duration: 1500,
                        zoomScale: 1.3,
                    },
                    urban_processes: {
                        layer: 'lyr_urban_processes',
                        source: 'vs_urban_processes',
                        zindex: 1000,
                        duration: 1500,
                        zoomScale: 1.25,
                    },
                },
                style: {

                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;